import React, { useState } from 'react';
import { HiOutlineTrash } from 'react-icons/hi2';
import { formatGrantDate, grantScopeLabel } from '../../../utils/oauthGrants';
import { resolveClientIdentity } from '../../../utils/mcpClients';

// One OAuth-connected AI app, shared by every grant surface so their marks and
// fallbacks can't drift. Chrome-neutral: the caller supplies the container.

const ConnectedClientRow = ({ grant, onDisconnect, disconnecting, showConnectedBy = false }) => {
  const [confirming, setConfirming] = useState(false);
  const { label, host, Mark } = resolveClientIdentity(grant);
  const busy = Boolean(disconnecting);

  return (
    <div className="flex items-center gap-3 px-4 py-3">
      <div className="flex-shrink-0 w-8 h-8 rounded-lg overflow-hidden ring-1 ring-gray-200/80 dark:ring-gray-700/60 flex items-center justify-center bg-white dark:bg-gray-800">
        {/* Wrapper already clips; the favicon fallback ignores the prop. */}
        <Mark className="w-full h-full" rounded="rounded-none" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{label}</span>
          <span className="text-[11px] font-medium px-1.5 py-0.5 rounded bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400 flex-shrink-0">
            {grantScopeLabel(grant.scopes)}
          </span>
        </div>
        <p className="text-xs text-gray-400 dark:text-gray-500 truncate">
          {/* Keep the verified host visible even behind a friendly name. */}
          {host && host !== label && `${host} · `}
          Connected {formatGrantDate(grant.createdAt)}
          {showConnectedBy && grant.connectedBy && ` by ${grant.connectedBy}`}
          {grant.lastUsedAt && ` · last used ${formatGrantDate(grant.lastUsedAt)}`}
        </p>
      </div>
      {confirming ? (
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={() => onDisconnect(grant.id)}
            disabled={busy}
            className="text-xs font-medium px-3 py-1.5 rounded-lg bg-red-600 hover:bg-red-700 text-white disabled:opacity-50 transition-colors"
          >
            {busy ? 'Disconnecting…' : 'Confirm'}
          </button>
          <button
            onClick={() => setConfirming(false)}
            disabled={busy}
            className="text-xs font-medium px-3 py-1.5 rounded-lg border border-gray-300 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
          >
            Keep
          </button>
        </div>
      ) : (
        <button
          onClick={() => setConfirming(true)}
          className="flex-shrink-0 inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-lg border border-gray-300 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:border-red-300 hover:text-red-600 dark:hover:border-red-700 dark:hover:text-red-400 transition-colors"
        >
          <HiOutlineTrash className="w-3.5 h-3.5" />
          Disconnect
        </button>
      )}
    </div>
  );
};

export default ConnectedClientRow;
